import { staticText } from "../../../utils/translations/staticText";

export const baseTranslations = {
 approval_odds_date_format: {
    _: 'dd MMM yyyy',
    zh: 'yyyy年M月d日',
  },	
 popup_title: {
    _: 'Your Chance of Approval',
    zh: '你的批核機會',
  },
  approval_odds_determined: {
    _: 'How are Approval Odds Determined?',
    zh: '批核機會如何釐定？',
  },
  determined_description: {
    _: 'Odds are based on comparing your TransUnion credit profile with each products general requirements',
    zh: '批核機會根據你的環聯信貸資料與各產品的一般要求比對而成。',
  },
  last_updated_label: {
    _: 'Approval Odds Updated ',
    zh: '批核機會更新日期：',
  },
  disclaimer: {
    _: 'Approval odds are estimates only and do not guarantee approval or rejection. Final decisions are made by the lender. ',
    zh: '批核機會僅為估算，並不保證獲批或被拒。最終決定由貸款機構作出。',
  },
  disclaimer_tnc_link: {
    _: 'View full terms and conditions.',
    zh: '查看完整條款及細則。',
  },
  button_mini_description: {
    _: 'Requires SMS verification via TransUnion (~1 min)',
    zh: '需透過環聯進行短訊驗證（約1分鐘）',
  },
  button_label: {
    _: 'Update My Credit Data',
    zh: '更新我的信貸資料',
  },
   approval_odds_high: {
    _: 'High',
    zh: '高',
  },
  approval_odds_medium: {
    _: 'Medium',
    zh: '中',
  },
  approval_odds_low: {
    _: 'Low',
    zh: '低',
  },
  approval_odds_unlock: {
    _: 'Unlock',
    zh: '解鎖',
  },
  high_chance: {
    _: 'Good Chance',
    zh: '機會高',
  },
  medium_chance: {
    _: 'Fair Chance',
    zh: '機會一般',
  },
  low_chance: {
    _: 'Low Chance',
    zh: '機會低',
  },
  none_chance: {
    _: 'Not Available',
    zh: '目前暫無',
  },
  high_description: {
    _: 'Your credit profile meets most or all of this products general requirements.',
    zh: '你的信貸狀況符合此產品的大部分或全部一般要求。',
  },
  medium_description: {
    _: 'Your credit profile meets some but not all requirements. Approval is possible but not certain.',
    zh: '你的信貸狀況符合部分要求，有機會獲批但並不確定。',
  },
  low_description: {
    _: 'Your credit profile may not meet this products general requirements. Applying may result in a hard enquiry without a successful outcome.',
    zh: '你的信貸狀況可能未符合此產品的一般要求，申請或會產生硬性查詢而未能成功獲批。',
  },
  none_description: {
    _: 'Approval odds are not available for this product yet. You can still apply as usual.',
    zh: '此產品暫未提供批核機會。你仍可如常申請。',
  },
  outdated_data_alert: {
    _: 'Your Credit Data is Outdated',
    zh: '你的信貸資料已過期', 
  },
  updated_data_reminder: {
    _: 'Your Credit Data is Up to Date',
    zh: '你的信貸資料已是最新', 
 },
  outdated_state_explanation: {
    _: 'Your credit profile may have changed. Refresh to see odds based on your latest data.',
    zh: '你的信貸狀況可能已變更,重新整理以根據最新資料查看批核機會。', 
  }

};
export const TRANSLATIONS = staticText(baseTranslations);